import React from 'react';
import useThemeColors from '../../hooks/useThemeColors';

const AnalyticsTabs = ({ 
  activeTab, 
  onTabChange, 
  tabs = [], 
  className = "" 
}) => {
  const { isDark, colors } = useThemeColors();
  
  return (
    <div className={`space-y-6 ${className}`}>
      <div className={`flex flex-wrap gap-2 border-b ${
        isDark ? 'border-gray-700' : 'border-gray-200'
      }`}>
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => onTabChange(tab.value)}
            className={`px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium rounded-t-lg transition-colors ${
              activeTab === tab.value
                ? `${isDark ? 'bg-gray-800' : 'bg-white'} border-b-2 border-purple-500 ${
                    isDark ? 'text-purple-400' : 'text-purple-600'
                  }`
                : `${isDark ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-800' : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'}`
            } ${tab.className || ''}`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsTabs; 